import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiChannel } from 'core/constants';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';
import { EsimChange } from './models';
import { StoreAction } from 'store/actions';

@Injectable()
export class EsimApi {
    public static esimChange(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<EsimChange> {
        return http.post(`/lines/${params.lineId}/esims/change`, params.payLoad, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: ApiResponse) => EsimChange.create<EsimChange>(response))
        );
    }
}
ModelBase.persistMapping[StoreAction.ESIM_CHANGE] = EsimApi.esimChange;
